module.exports = __webpack_public_path__ + "media/images/bg_first-step-775bf3655ddf58d1214517b483bbaeea.jpg";